import template from './user-invoices.html';
import userInvoicesController from './user-invoices.controller';
import './user-invoices.styl';

let userInvoicesComponent = {
  restrict: 'E',
  bindings: {
    user: '=',
  },
  template,
  controller: userInvoicesController,
  controllerAs: 'vm'
};

export default userInvoicesComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-invoices/user-invoices.component.js
 **/